/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForesightScenarioFactor'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ForesightScenarioFactor'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioElementReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForesightScenarioFactor);
  }
}(this, function(ApiClient, ForesightScenarioFactor) {
  'use strict';




  /**
   * The ForesightScenarioElementReport model module.
   * @module model/ForesightScenarioElementReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForesightScenarioElementReport</code>.
   * @alias module:model/ForesightScenarioElementReport
   * @class
   */
  var exports = function() {
    var _this = this;














  };

  /**
   * Constructs a <code>ForesightScenarioElementReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForesightScenarioElementReport} obj Optional instance to populate.
   * @return {module:model/ForesightScenarioElementReport} The populated <code>ForesightScenarioElementReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('PastIndicatorID')) {
        obj['PastIndicatorID'] = ApiClient.convertToType(data['PastIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('FutureIndicatorID')) {
        obj['FutureIndicatorID'] = ApiClient.convertToType(data['FutureIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Factors')) {
        obj['Factors'] = ApiClient.convertToType(data['Factors'], [ForesightScenarioFactor]);
      }
      if (data.hasOwnProperty('LevelID')) {
        obj['LevelID'] = ApiClient.convertToType(data['LevelID'], 'Integer');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('BaselineCalculationID')) {
        obj['BaselineCalculationID'] = ApiClient.convertToType(data['BaselineCalculationID'], 'Integer');
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('Updated')) {
        obj['Updated'] = ApiClient.convertToType(data['Updated'], 'Date');
      }
      if (data.hasOwnProperty('CalculatePeriodsAfter')) {
        obj['CalculatePeriodsAfter'] = ApiClient.convertToType(data['CalculatePeriodsAfter'], 'Date');
      }
      if (data.hasOwnProperty('CalculatePeriodsBefore')) {
        obj['CalculatePeriodsBefore'] = ApiClient.convertToType(data['CalculatePeriodsBefore'], 'Date');
      }
      if (data.hasOwnProperty('ManualShare')) {
        obj['ManualShare'] = ApiClient.convertToType(data['ManualShare'], 'Number');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} PastIndicatorID
   * @default 0
   */
  exports.prototype['PastIndicatorID'] = 0;
  /**
   * @member {Integer} FutureIndicatorID
   * @default 0
   */
  exports.prototype['FutureIndicatorID'] = 0;
  /**
   * @member {Array.<module:model/ForesightScenarioFactor>} Factors
   */
  exports.prototype['Factors'] = undefined;
  /**
   * @member {Integer} LevelID
   * @default 0
   */
  exports.prototype['LevelID'] = 0;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} BaselineCalculationID
   * @default 0
   */
  exports.prototype['BaselineCalculationID'] = 0;
  /**
   * @member {Integer} ResponsibleUserID
   * @default 0
   */
  exports.prototype['ResponsibleUserID'] = 0;
  /**
   * @member {Date} Updated
   */
  exports.prototype['Updated'] = undefined;
  /**
   * @member {Date} CalculatePeriodsAfter
   */
  exports.prototype['CalculatePeriodsAfter'] = undefined;
  /**
   * @member {Date} CalculatePeriodsBefore
   */
  exports.prototype['CalculatePeriodsBefore'] = undefined;
  /**
   * @member {Number} ManualShare
   * @default 0.0
   */
  exports.prototype['ManualShare'] = 0.0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


